import { SettingsObject } from '@hooks/useSettings';

export const prPpe: Partial<SettingsObject> = {};
